// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "288ccd8e445c5a468c97" + ".js";
};